import {
  NButton,
  NHeading,
  NText,
  NInput,
  NLoading,
  NBottomSheet,
  NRadio,
  NRadioGroup,
  NToast,
  NProgress,
  NTransitionFade,
  NListbox,
  NListboxOption,
  NBox,
  NCheckbox,
  NPopper,
  NTable,
  NTableColumn,
  NDialog,
  NCheap,
  NTab,
  NTabs,
  NButtonToggle,
  NButtonToggleGroup,
  NButtonIcon,
  NAccordionGroup,
  NAccordion,
  NTabtables,
  NTabtable,
} from '@negar/core';
import type { App } from 'vue';

const install = (Vue: App) => {
  // https://youtrack.jetbrains.com/issue/WEB-48239
  // Globally registered components are not fully recognizable by Webstorm.
  // As a result, we can't use app.use(Negar) or app.component(NInput), otherwise we loose code intellisense.
  // A silly workaround is to use Vue.component explicitly for each component
  Vue.component('NText', NText);
  Vue.component('NInput', NInput);
  Vue.component('NButton', NButton);
  Vue.component('NHeading', NHeading);
  Vue.component('NLoading', NLoading);
  Vue.component('NBottomSheet', NBottomSheet);
  Vue.component('NRadio', NRadio);
  Vue.component('NRadioGroup', NRadioGroup);
  Vue.component('NProgress', NProgress);
  Vue.component('NTransitionFade', NTransitionFade);
  Vue.component('NListbox', NListbox);
  Vue.component('NListboxOption', NListboxOption);
  Vue.component('NBox', NBox);
  Vue.component('NPopper', NPopper);
  Vue.use(NToast, {
    queued: true,
    position: 'top',
    offset: 30,
  });
  Vue.component('NCheckbox', NCheckbox);
  Vue.component('NTable', NTable);
  Vue.component('NTableColumn', NTableColumn);
  Vue.use(NDialog, {
    appContext: Vue._context,
  });
  Vue.component('NCheap', NCheap);
  Vue.component('NTab', NTab);
  Vue.component('NTabs', NTabs);
  Vue.component('NButtonToggle', NButtonToggle);
  Vue.component('NButtonToggleGroup', NButtonToggleGroup);
  Vue.component('NButtonIcon', NButtonIcon);
  Vue.component('NAccordionGroup', NAccordionGroup);
  Vue.component('NAccordion', NAccordion);
  Vue.component('NTabtable', NTabtable);
  Vue.component('NTabtables', NTabtables);
};

export { install };
